import { useMemo } from 'react'
import type { Currency } from '@/shared/models/moneyModel'
import { sortCurrencies } from '@/shared/models/moneyModel'
import { useCompanyConfig } from './useCompanyConfig'

const DEFAULT_CURRENCIES: Currency[] = ['EUR']

/** The currencies of the company config, sorted. None while the config loads, EUR when it has none. */
export const useAvailableCurrencies = (): Currency[] => {
    const currencyConfigs = useCompanyConfig().data?.body?.currencyConfigs

    return useMemo(() => {
        if (!currencyConfigs) return []

        const currencies = currencyConfigs.map(({ currency }) => currency)
        return currencies.length ? sortCurrencies(currencies) : DEFAULT_CURRENCIES
    }, [currencyConfigs])
}
